import React, { useState } from 'react';

const WebsiteReviewsChart = () => {
  // Website review data
  const websiteData = {
    landingPage: [
      { site: 'cardgamer.com', visitors: 5, emoji: '🎮' },
      { site: 'bordspellencafe.nl', visitors: 2, emoji: '☕' },
      { site: 'geekdad.com', visitors: 1, emoji: '👨‍👧' },
      { site: 'Instagram creators', visitors: 21, emoji: '📷' },
      { site: 'Reddit', visitors: 98, emoji: '🔴' },
      { site: 'BoardGameGeek (EndersGame)', visitors: 69, emoji: '🎲' }
    ],
    kickstarter: [
      { site: 'cardgamer.com', visitors: 3, emoji: '🎮' },
      { site: 'geekdad.com', visitors: 2, emoji: '👨‍👧' },
      { site: 'bordspellencafe.nl', visitors: 1, emoji: '☕' },
      { site: 'nox-spellenzolder.nl', visitors: 1, emoji: '🏪' },
      { site: 'YouTube creators', visitors: 120, emoji: '▶️' },
      { site: 'BoardGameGeek', visitors: 168, emoji: '🎲' }
    ],
    kickstarterDashboard: [
      { site: 'spacecowboys', backers: 1, amount: 29, emoji: '🤠' },
      { site: 'Jongetgames', backers: 3, amount: 59, emoji: '🎲' },
      { site: 'Instagram creators', backers: 1, amount: 3, emoji: '📷' },
      { site: 'Reddit (EndersGame)', backers: 7, amount: 187, emoji: '🔴' },
      { site: 'BoardGameGeek (EndersGame)', backers: 10, amount: 270, emoji: '🎲' },
      { site: 'YouTube creators', backers: 7, amount: 133, emoji: '▶️' }
    ]
  };

  // State to track which view to show
  const [activeView, setActiveView] = useState('landingPage');

  // Calculate totals
  const landingPageTotal = websiteData.landingPage.reduce((sum, item) => sum + item.visitors, 0);
  const kickstarterTotal = websiteData.kickstarter.reduce((sum, item) => sum + item.visitors, 0);
  const dashboardTotalBackers = websiteData.kickstarterDashboard.reduce((sum, item) => sum + item.backers, 0);
  const dashboardTotalAmount = websiteData.kickstarterDashboard.reduce((sum, item) => sum + item.amount, 0);

  // Get max value for scaling bars
  const getMaxValue = () => {
    if (activeView === 'landingPage') {
      return Math.max(...websiteData.landingPage.map(item => item.visitors));
    } else if (activeView === 'kickstarter') {
      return Math.max(...websiteData.kickstarter.map(item => item.visitors));
    } else {
      return Math.max(...websiteData.kickstarterDashboard.map(item => item.backers));
    }
  };

  const maxValue = getMaxValue();

  return (
    <div className="website-reviews-chart">
      <h3>🔍Non-Ad Traffic Analysis</h3>
      <p>Let's also have a look at the traffic and attributed gross from all posts, videos and reviews.</p>
      
      <div className="chart-toggle">
        <button 
          className={`chart-toggle-btn ${activeView === 'landingPage' ? 'active' : ''}`}
          onClick={() => setActiveView('landingPage')}
        >
          🏠 Landing Page
        </button>
        <button 
          className={`chart-toggle-btn ${activeView === 'kickstarter' ? 'active' : ''}`}
          onClick={() => setActiveView('kickstarter')}
        >
          🚀 Kickstarter
        </button>
        <button 
          className={`chart-toggle-btn ${activeView === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveView('dashboard')}
        >
          📈 KS Dashboard
        </button>
      </div>
      
      <div className="website-chart-container">
        {activeView === 'landingPage' && (
          <>
            <div className="chart-summary">
              <span className="chart-total">👥 Total Visitors: {landingPageTotal}</span>
            </div>
            <div className="website-bars">
              {websiteData.landingPage.map((item, index) => (
                <div key={index} className="website-bar-item">
                  <div className="website-name">{item.emoji} {item.site}</div>
                  <div className="bar-container">
                    <div 
                      className="website-bar" 
                      style={{ 
                        width: `${(item.visitors / maxValue) * 100}%`,
                        backgroundColor: `hsl(${210 + index * 30}, 80%, 60%)`
                      }}
                    >
                      <span className="bar-label">{item.visitors}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        
        {activeView === 'kickstarter' && (
          <>
            <div className="chart-summary">
              <span className="chart-total">👥 Total Visitors: {kickstarterTotal}</span>
            </div>
            <div className="website-bars">
              {websiteData.kickstarter.map((item, index) => (
                <div key={index} className="website-bar-item">
                  <div className="website-name">{item.emoji} {item.site}</div>
                  <div className="bar-container">
                    <div 
                      className="website-bar" 
                      style={{ 
                        width: `${(item.visitors / maxValue) * 100}%`,
                        backgroundColor: `hsl(${210 + index * 30}, 80%, 60%)`
                      }}
                    >
                      <span className="bar-label">{item.visitors}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        
        {activeView === 'dashboard' && (
          <>
            <div className="chart-summary">
              <span className="chart-total">👥 Total Backers: {dashboardTotalBackers} | 💰 Total Amount: €{dashboardTotalAmount}</span>
            </div>
            <div className="website-bars">
              {websiteData.kickstarterDashboard.map((item, index) => (
                <div key={index} className="website-bar-item">
                  <div className="website-name">{item.emoji} {item.site}</div>
                  <div className="bar-container">
                    <div 
                      className="website-bar" 
                      style={{ 
                        width: `${(item.backers / maxValue) * 100}%`,
                        backgroundColor: `hsl(${210 + index * 30}, 80%, 60%)`
                      }}
                    >
                      <span className="bar-label">{item.backers} backers (€{item.amount})</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      
      <div className="website-insights">
        <h4>💡 Key Insights</h4>
        <ul>
          <li>📉 Very minimal traffic across all creators and reviewers.</li>
          <li>🎲 EndersGame provided the most visitors to both landing page and Kickstarter</li>
          <li>🎲 Endersgame also drove the most backers (7) and revenue (€187)</li>
          <li>⚠️ Total direct conversion from reviews, videos and posts was minimal</li>
        </ul>
      </div>
    </div>
  );
};

export default WebsiteReviewsChart;
